export type PaymentProviderCapability = 'DepositPayments' | 'CancellationChargePayments' | 'VoucherPayments'

export type PaymentGateway = 'stripe' | 'breathepay' | 'ryftpay' | 'dojo' | 'tablesense-test' | 'teya'

export class PaymentsAccount {
    constructor(
        public id: string,
        public gateway: PaymentGateway,
        public applePayEnabled: boolean = false,
        public capabilities: PaymentProviderCapability[] = PaymentsAccount.capabilitiesForGateway(gateway)
    ) { }

    usesStripe(): boolean {
        return this.gateway === 'stripe'
    }

    usesBreathePay(): boolean {
        return this.gateway === 'breathepay'
    }

    usesRyftPay(): boolean {
        return this.gateway === 'ryftpay'
    }

    usesTeya(): boolean {
        return this.gateway === 'teya'
    }

    usesDojo(): boolean {
        return this.gateway === 'dojo'
    }

    supports(capability: PaymentProviderCapability): boolean {
        return this.capabilities.includes(capability)
    }

    private static capabilitiesForGateway(gateway: PaymentGateway): PaymentProviderCapability[] {
        return ['dojo', 'teya', 'tablesense-test'].includes(gateway)
            ? ['DepositPayments', 'CancellationChargePayments']
            : ['DepositPayments', 'CancellationChargePayments', 'VoucherPayments']
    }
}
